import { Stethoscope } from 'lucide-react';

import { useMyDosespotClinicianInfoQuery } from '@/entities/dosespot-clinician';

/**
 * Displays the prescriber's registered demographic info per ACR S.103.1:
 * "Sender demographic information, when included in the message, shall
 * match what was registered by the customer in the Surescripts Directory."
 *
 * Shows the clinician's name and address as registered in DoseSpot,
 * which corresponds to their SureScripts Directory entry.
 */
export function PrescriberInfo() {
  const clinicianQuery = useMyDosespotClinicianInfoQuery();
  const info = clinicianQuery.data;

  if (!info) {
    return null;
  }

  const fullName = [info.Prefix, info.FirstName, info.LastName, info.Suffix]
    .filter(Boolean)
    .join(' ');
  const cityStateZip =
    [info.City, info.State].filter(Boolean).join(', ') + (info.ZipCode ? ` ${info.ZipCode}` : '');

  return (
    <details className="group text-xs text-muted-foreground">
      <summary className="flex cursor-pointer list-none items-center gap-2 py-1 hover:text-foreground">
        <Stethoscope className="size-3.5" aria-hidden />
        Prescriber and routing details
      </summary>
      <div className="mt-2 border-l border-border/60 pl-5 leading-5">
        <div className="font-medium text-foreground/80">{fullName}</div>
        {info.Address1 ? <div>{info.Address1}</div> : null}
        {cityStateZip ? <div>{cityStateZip}</div> : null}
      </div>
    </details>
  );
}
